import { render, staticRenderFns } from "./CoTwoSetCreationForm.vue?vue&type=template&id=e9d78038&scoped=true&"
import script from "./CoTwoSetCreationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoSetCreationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d78038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9d78038')) {
      api.createRecord('e9d78038', component.options)
    } else {
      api.reload('e9d78038', component.options)
    }
    module.hot.accept("./CoTwoSetCreationForm.vue?vue&type=template&id=e9d78038&scoped=true&", function () {
      api.rerender('e9d78038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoSetCreationForm.vue"
export default component.exports